<!-- eslint-disable no-console -->
<template>
   <gat-form>
      <gat-group title="Import statements" :collapsed="true">
         <v-layout wrap>
            <gat-edit v-model="csvData" size="xs12" label="CSV data" rows="10" />
            <v-btn flat @click="importData = parseCsvData(csvData.trim())">Parse data</v-btn>
            <v-btn
               flat
               @click="selectAll()"
               :disabled="importData.length == 0 || selectedStatements.length == importData.length"
               >select all</v-btn
            >
            <v-btn flat @click="importCardTransactions()" :disabled="selectedStatements.length == 0"
               >import credit card transactions</v-btn
            >
         </v-layout>
         <gat-grid :items="importData" :columns="gridColumns">
            <template slot="cell" slot-scope="slotprops" v-if="slotprops.column.header == 'Import'">
               <gat-edit class="gridCheckbox" v-model="slotprops.row.doImport" :checkbox="true" />
            </template>
         </gat-grid>
         Selected amount: {{ selectedAmount }}
      </gat-group>
      <gat-group title="open card transactions" :collapsed="false">
         <v-btn flat @click="getOpenTrans()" color="blue">refresh</v-btn>
         <v-btn flat @click="selectAllOpenTrans()">Select all</v-btn>
         <v-btn flat @click="setInvoiceDataOnSelectedTrans()" color="blue" :disabled="selectedOpenTrans.length < 1"
            >set invoice data</v-btn
         >
         <v-btn flat @click="createBankTransaction()">Create transactions</v-btn>
         <v-layout wrap>
            <gat-select v-model="cardNameFilter" :items="getCardNames" clearable label="card filter" size="xs2" />
            <gat-select v-model="invoiceFilter" :items="getInvoiceNames" clearable label="invoice filter" size="xs3" />
            <gat-edit v-model="invoiceName" label="Invoice name" size="xs3" />
            <gat-edit v-model="invoiceDate" :dateEdit="true" label="Invoice date" size="xs2" />
         </v-layout>
         <gat-grid dense :items="filteredOpenTransactions" :columns="openTransgridColumns">
            <template slot="cell" slot-scope="slotprops" v-if="slotprops.column.header == 'Import'">
               <gat-edit class="gridCheckbox" v-model="slotprops.row.doImport" :checkbox="true" />
            </template>
         </gat-grid>
         <div class="mt-2 pb-1">
            <span>Sum transactions:{{ sumTransactions }}</span>
            <span class="ml-4">Sum selected: {{ sumSelectedTrans }}</span>
            <v-btn flat @click="deleteSelectedTrans()" :disabled="selectedOpenTrans.length < 1">
               delete selected
            </v-btn>
         </div>
      </gat-group>
   </gat-form>
</template>

<script lang="ts">
import Vue from "vue";
import GatGroup from "../../GatComponents/GatGroup.vue";
import GatEdit from "../../GatComponents/GatEdit.vue";
import GatForm from "../../GatComponents/GatForm.vue";
import GatGrid from "../../GatComponents/GatGrid.vue";
import { apiPost, apiGet, apiDelete } from "../../dal";
import GatSelect from "../../GatComponents/GatSelect.vue";

export default Vue.extend({
   name: "CreditCard",
   components: { GatGroup, GatEdit, GatForm, GatGrid, GatSelect },
   props: {},
   data() {
      return {
         csvData: "",
         cardNameFilter: "",
         invoiceFilter: "",
         invoiceName: "",
         invoiceDate: null,
         importData: [],
         openTransactions: [],
      };
   },

   activated() {},

   mounted() {
      this.getOpenTrans();
   },

   deactivated() {},

   computed: {
      filteredOpenTransactions() {
         let result = this.openTransactions;
         if (this.cardNameFilter) {
            result = result.filter((item) => item.CARD_NAME === this.cardNameFilter);
         }

         if (this.invoiceFilter) {
            result = result.filter((item) => item.INVOICE_NAME === this.invoiceFilter);
         }
         return result;
      },

      getCardNames() {
         var extractedCardNames = this.openTransactions.map((item) => {
            return item.CARD_NAME;
         });
         extractedCardNames.push("");
         return extractedCardNames;
      },

      getInvoiceNames() {
         var extractedInvoiceNames = this.openTransactions.map((item) => {
            return item.INVOICE_NAME;
         });
         extractedInvoiceNames.push("");
         return extractedInvoiceNames;
      },

      gridColumns() {
         const columns = [
            { header: "Import", field: "doImport" },
            { header: "Date", field: "transDate" },
            { header: "Amount", field: "amount" },
            { header: "Supplier", field: "supplier" },
            { header: "Category", field: "category" },
            { header: "Notes", field: "notes" },
            { header: "Card", field: "cardName" },
         ];
         return columns;
      },

      openTransgridColumns() {
         const columns = [
            { header: "Import", field: "doImport" },
            { header: "Date", field: "TRANS_DATE", dataType: "date" },
            {
               header: "Amount",
               field: "AMOUNT",
               dataType: "number",
               numberFormat: "0,0.00",
               footerFunction: { fn: "sum" },
            },
            { header: "Supplier", field: "SUPPLIER" },
            { header: "Notes", field: "NOTES" },
            { header: "Card", field: "CARD_NAME" },
            { header: "Invoice", field: "INVOICE_NAME" },
            { header: "Invoice date", field: "INVOICE_DATE", dataType: "date" },
         ];
         return columns;
      },

      selectedStatements() {
         return this.importData.filter((item) => item.doImport === true);
      },

      selectedOpenTrans() {
         return this.filteredOpenTransactions.filter((item) => item.doImport === true);
      },

      selectedAmount() {
         let result = 0;
         this.selectedStatements.map((item) => (result = result + item.amount));
         return result;
      },

      sumSelectedTrans() {
         let sum = 0;
         this.selectedOpenTrans.forEach((item) => {
            sum = sum + item.AMOUNT;
         });
         return sum;
      },

      sumTransactions() {
         let sum = 0;
         this.filteredOpenTransactions.forEach((item) => {
            sum = sum + item.AMOUNT;
         });
         return sum;
      },
   },

   methods: {
      createBankTransaction() {
         const bankTransactions = this.selectedOpenTrans.map((item) => {
            return {
               TRA_DATE: item.INVOICE_DATE,
               TRA_REF: item.INVOICE_NAME,
               TRA_TEXT: item.SUPPLIER + ": " + item.NOTES,
               TRA_AMOUNT: item.AMOUNT * -1,
               TRA_TYPE: "Credit-card",
               TRA_ORG_LINE: JSON.stringify(item),
               TRA_ACCOUNT: "REGNINGSKONTO",
               cc_trans_id: item.ID,
            };
         });
         apiPost("db/transactions", bankTransactions).then((result) => {
            const newTrans = result.inserted.map((resultItem) => {
               return {
                  cc_trans_id: resultItem.transaction.cc_trans_id,
                  bank_trans_id: resultItem.bankTransId,
               };
            });
            if (newTrans.length > 0) {
               apiPost("db/creditcard/setBankTransaction", newTrans).then(() => {
                  this.getOpenTrans();
               });
            }
         });
      },

      deleteSelectedTrans() {
         const transIds = this.selectedOpenTrans.map((item) => item.ID);
         apiDelete("db/creditcard/transactions", transIds).then((result) => {
            this.openTransactions = result;
         });
      },

      getItemFromLine(headers, items, colName) {
         let idx = headers.indexOf(colName);

         if (idx === -1) {
            return null;
         }

         let result = items[idx];
         result = result.replace('"', "");
         result = result.replace('"', "");
         return result;
      },

      getOpenTrans() {
         apiGet("db/creditcard/transactions").then((result) => {
            this.openTransactions = result;
         });
      },

      importCardTransactions() {
         apiPost("db/creditcard/transactions", this.selectedStatements).then((result) => {
            this.openTransactions = result;
         });
      },

      parseCsvData(data) {
         const result = [];
         const lines = data.split("\n");
         const headers = lines[0].split(",").map((item) => item.trim());

         for (let index = 1; index < lines.length; index++) {
            const line = lines[index];
            const items = line.split(",").map((item) => item.trim());
            const record = {
               doImport: false,
               cardName: "",
               transDate: new Date(),
               supplier: "",
               amount: 0.0,
               notes: "",
               billTransId: null,
               category: "",
               transId: null,
            };

            record.cardName = this.getItemFromLine(headers, items, "Card Name");
            record.transDate = this.getItemFromLine(headers, items, "Date (YYYY-MM-DD as UTC)");
            const timeStr = this.getItemFromLine(headers, items, "Time (HH:MM:SS)");
            record.transDate = record.transDate + "T" + timeStr;
            record.supplier = this.getItemFromLine(headers, items, "Merchant");
            record.amount = parseFloat(this.getItemFromLine(headers, items, "Txn Amount (Funding Card)"));
            record.notes = this.getItemFromLine(headers, items, "Notes");
            record.category = this.getItemFromLine(headers, items, "Category");
            result.push(record);
         }
         return result;
      },

      selectAll() {
         this.importData.map((item) => (item.doImport = true));
      },

      selectAllOpenTrans() {
         this.filteredOpenTransactions.forEach((checkedItem) => {
            checkedItem.doImport = true;
            const idx = this.openTransactions.findIndex((item) => item.ID === checkedItem.ID);
            this.openTransactions.splice(idx, 1, checkedItem);
         });
      },

      setInvoiceDataOnSelectedTrans() {
         const params = { cc_trans_ids: [], invoiceName: "", invoiceDate: null };
         params.cc_trans_ids = this.selectedOpenTrans.map((item) => item.ID);
         params.invoiceName = this.invoiceName;
         params.invoiceDate = this.invoiceDate;
         apiPost("db/creditcard/invoice-name", params).then((result) => {
            this.openTransactions = result;
         });
      },
   },
});
</script>

<style scoped>
.gridCheckbox {
   margin-top: 12px;
   margin-bottom: -12px;
}
</style>
